angular.module 'zc.master.zcliteKpi'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.zcliteKpi',
    url: '/zclite_kpi'
    views:
      'content@':
        templateUrl: '/templates/master.zclite_kpi/list.html'
        controller: 'MasterZcliteKpiCtrl'
        resolve:
          projects: (MasterProject) ->
            MasterProject.all()
          agencies: (MasterAgency) ->
            MasterAgency.all()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_kpi/routes.coffee